<template>
    <a href="/logout" @click="submitForm" class="logout-link">
        <slot></slot>

        <form action="/logout" method="POST" style="display: none;">
            <input type="hidden" name="_token" v-model="csrf" hidden/>
        </form>
    </a>
</template>

<script>
export default {
    props: {
        fullName: String
    },

    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        };
    },

    methods: {
        submitForm(event) {
            event.preventDefault();
            this.$el.querySelector('form').submit();
        }
    }
}
</script>
